export default __webpack_public_path__ + "static/media/3.7636a9b5.png";